import {RouteObject} from 'react-router-dom';
import {ProtectedElement} from '../auth/require-authorization';
import {AllRoles} from '../navigation/links';
import {ROUTES} from '../routes';
import {Dashboard} from './dashboard';

export const DashboardRoutes: RouteObject = {
  path: ROUTES.DASHBOARD.path,
  element: (
    <ProtectedElement role={AllRoles}>
      <Dashboard />
    </ProtectedElement>
  ),
};
